export const SHOW_ERROR = 'SHOW_ERROR';
export const SHOW_ERRORS = 'SHOW_ERRORS';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const SHOW_TOAST = 'SHOW_TOAST';
export const CLOSE_TOAST = 'CLOSE_TOAST';
